// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';

// layout.js
export const LEFT_MENU = 'LEFT_MENU';
export const ROUTE_CHANGE = 'ROUTE_CHANGE';
export const ACTIVE_MENU = 'ACTIVE_MENU';

// trajectory_enrolments
export const SET_ENROLMENTS = 'SET_ENROLMENTS';

//tabs
export const SET_TAB_STATE = 'SET_TAB_STATE';

// Navigation history
export const HISTORY_ADD = 'HISTORY_ADD';
export const HISTORY_CLEAR = 'HISTORY_CLEAR';

// Dashboard
export const SET_TODOS_AMOUNT = 'SET_TODOS_AMOUNT';

// Settings
export const SETTINGS_SET_SUCCESS = 'SETTINGS_SET_SUCCESS';
export const SETTINGS_SET_FAILURE = 'SETTINGS_SET_FAILURE';
export const SETTINGS_VALUES_SET_SUCCESS = 'SETTINGS_VALUES_SET_SUCCESS';
export const SETTINGS_VALUES_SET_FAILURE = 'SETTINGS_VALUES_SET_FAILURE';
